import { getCurrentDateStartAndEndTime } from './utils.js'
export const defaultShortCuts = that => {
  let dateRange = getCurrentDateStartAndEndTime()
  return {
    shortcuts: [
      {
        text: that.$t('statistics.today'),
        onClick(picker) {
          picker.$emit('pick', [dateRange[0], dateRange[1]])
        }
      },
      {
        text: that.$t('attendanceRecord.lastweek'),
        onClick(picker) {
          const start = new Date(dateRange[0].getTime() - 3600 * 1000 * 24 * 6)
          picker.$emit('pick', [start, dateRange[1]])
        }
      },
      {
        text: that.$t('attendanceRecord.lastmonth'),
        onClick(picker) {
          const start = new Date(dateRange[0].getTime() - 3600 * 1000 * 24 * 30)
          picker.$emit('pick', [start, dateRange[1]])
        }
      },
      {
        text: that.$t('attendanceRecord.lastThreeMonths'),
        onClick(picker) {
          const start = new Date(dateRange[0].getTime() - 3600 * 1000 * 24 * 90)
          picker.$emit('pick', [start, dateRange[1]])
        }
      }
    ]
  }
}
export default defaultShortCuts



// WEBPACK FOOTER //
// ./src/utils/pickerOptions.js